import { PageTitle } from "components";
import { useChannelList } from "hooks";
import { ChannelListTable, CreateChannelDialog, CreateGroupDialog } from "./components";
import ChannelActions from "./components/ChannelActions";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { IconSpeakerphone, IconUsers } from "@tabler/icons-react";

const TAB_CHANNEL = "channel";
const TAB_GROUP = "group";

const ChannelManagement = () => {
  const { channels, totalChannels, page, totalPages, isFetching, handleSearchChange, handlePageChange, channelSize, handleChannelSizeChange, groupType, handleGroupTypeChange } =
    useChannelList();
  const { t: getLabel } = useTranslation();
  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleOpenCreateDialog = () => {
    setIsCreateDialogOpen(true);
  };

  const handleCloseCreateDialog = () => {
    setIsCreateDialogOpen(false);
  };

  return (
    <div className="d-flex flex-column" style={{ height: "100%" }}>
      <PageTitle>{titleObjectContent.channelManagement}</PageTitle>

      <div className="card">
        <div className="card-header">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${groupType === TAB_CHANNEL ? "active" : ""}`}
                onClick={() => handleGroupTypeChange(TAB_CHANNEL)}
              >
                <IconSpeakerphone size={16} className="me-1" />
                {getLabel(LangConstant.TXT_GROUP_TYPE_CHANNEL)}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${groupType === TAB_GROUP ? "active" : ""}`}
                onClick={() => handleGroupTypeChange(TAB_GROUP)}
              >
                <IconUsers size={16} className="me-1" />
                {getLabel(LangConstant.TXT_GROUP_TYPE_GROUP)}
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body d-flex flex-column gap-3">
          <ChannelActions
            onSearchChange={handleSearchChange}
            channelSize={channelSize}
            onChannelSizeChange={handleChannelSizeChange}
            onCreateChannel={handleOpenCreateDialog}
            groupType={groupType}
          />
          <ChannelListTable
            isFetching={isFetching}
            channels={channels}
            totalChannels={totalChannels}
            page={page}
            totalPages={totalPages}
            onChangePage={handlePageChange}
            groupType={groupType}
          />
        </div>
      </div>

      {groupType === TAB_CHANNEL ? (
        <CreateChannelDialog open={isCreateDialogOpen} onClose={handleCloseCreateDialog} />
      ) : (
        <CreateGroupDialog open={isCreateDialogOpen} onClose={handleCloseCreateDialog} />
      )}
    </div>
  );
};

export default ChannelManagement;
